<template>
  <div>
    <Navbar />

    <div>
      <b-row style="background-color: #0c0f6608 ; margin: 10px">
        <b-col md="6" lg="6" xs="6" style="text-align: right;">
          <img
            style="
              height: 450px;
              width: 450px;
              text-align: right;
            "
            :src="artist_image"
            fluid
            class="custom_hero_img"
          />
        </b-col>
        <b-col md="6" lg="6" xs="6" style="text-align: left; margin-top:20px">
          <div style="margin: 0px 30px">
            <h1 style="font-size: xxx-large; color: #0c0f66">
              {{ artist_full_name }}
            </h1>
            <p
              style="
                margin-top: 30px;
                max-width: 400px;
                color: #0c0f66;
                font-size: medium;
              "
            >
              {{ artist_bio }}
            </p>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-container class="container_homepage" style="">
      <b-row class="flex" style="margin: 20px" v-if=" exhibition_list.length > 0">
        <h3 class="your_choices mr-auto" style="">{{ page_heading }}</h3>
        <div
          class="input-group"
          style="width: 40%; border: 1px solid #0c0f66; border-radius: 30px"
        >
          <input
            v-model="search_exhibition"
            v-debounce:700ms="searchExhibition"
            type="text"
            class="form-control"
            placeholder="Search"
            style="height: 100%; border: none; border-radius: 30px"
          />
          <div class="input-group-append">
            <button
              class="btn"
              type="button"
              style="background-color: #0c0f66; border-radius: 30px; z-index: 0"
            >
              <b-icon icon="search" style="color: #fff"></b-icon>
            </button>
          </div>
        </div>
      </b-row>

      <Loader v-if="loading" />

      <div v-if="!loading && exhibition_list.length > 0">
        <b-row style="margin: 20px; display: flex; justify-content: space-around" v-show="search_flag">
          <div
            :key="exhibition.id"
            v-for="exhibition in exhibition_list"
            style="
              width: 23%;
              padding: 5px;
              margin: 5px;
              border: none !important;
            "
            class="card ex-card"
          >
            <ExhibitionCard :exhibition_json="exhibition" />
          </div>
        </b-row>
        <div v-show="!search_flag">
          <b-row style="margin: 20px; display: flex; justify-content: space-around" v-if="search_exhibition_list.length > 0">
            <div
           :key="exhibition.id"
              v-for="exhibition in search_exhibition_list"
            style="
              width: 23%;
              padding: 5px;
              margin: 5px;
              border: none !important;
            "
            class="card ex-card"
          >
            <ExhibitionCard :exhibition_json="exhibition" />
          </div>
          </b-row>
          <div v-else>
            <p>No results found</p>
          </div>
        </div>
        <br /><br />

        <div style="display: flex; justify-content: center" class="mx-auto">
          <button
            v-if="previous_url"
            class="btn next-or-previous-btn"
            style="margin: 10px"
            @click="previous_set_exhibitions(previous_url)"
          >
            &larr; Previous
          </button>
          <button
            v-if="next_url"
            class="btn next-or-previous-btn"
            style="margin: 10px"
            @click="next_set_exhibitions(next_url)"
          >
            Next &rarr;
          </button>
        </div>
      </div>
      <div v-else>
        <h1 style="margin:100px">Exhibtion Coming Soon</h1>
      </div>

      
    </b-container>
    <div v-if="artist_slug">
        <h3 class="your_choices mr-auto" style="">Artworks</h3>
        <ExploreArt :artist_slug="artist_slug"/>
      </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "../components/common/NavBar.vue";
import ExhibitionCard from "../components/Exhibition/ExhibitionCard.vue";
import Footer from "../components/common/Footer.vue";
import Loader from "../components/common/Loader.vue";
import ExploreArt from "./ExploreArt.vue"

export default {
  name: "Artist_Page",
  components: {
    Navbar,
    ExhibitionCard,
    Footer,
    Loader,
    ExploreArt
  },
  data() {
    return {
      loading: false,
      next_url: "",
      previous_url: "",
      filter_string: "&artist__artist__userprofile__user_slug=",
      page_heading: "Exhibitions",
      search_exhibition: "",
      search_flag: true,
      search_exhibition_list: {},

      artist_slug: "",
      exhibition_list: {},
      artist_image:"",
      artist_full_name:"",
      artist_bio:""
    };
  },
  methods: {
    reload() {
      this.load_initial_exhibitions();
    },

    next_set_exhibitions(url) {
      this.next_url = "";
      this.load_next_or_previous_exhibition(url);
      window.scrollTo(0, 0);
    },

    previous_set_exhibitions(url) {
      this.previous_url = "";
      this.load_next_or_previous_exhibition(url);
      window.scrollTo(0, 0);
    },

    load_initial_exhibitions() {
      this.filter_string += this.artist_slug;
      this.loading = true;
      this.$store
        .dispatch("getExhibitions", this.filter_string)
        .then((res) => {
          // console.log(res);
          if (res.results) {
            if (res.next) {
              this.next_url = res.next;
            }
            if (res.previous) {
              this.previous_url = res.previous;
            }
            // this.$store.commit("setExhibitionList", res);
            this.exhibition_list = res.results;
            if (this.exhibition_list.length < 1) {
              this.getArtistDetails()
            }
            else{
              this.artist_image = this.exhibition_list[0].artist.user_profile.avatar,
              this.artist_full_name =this.exhibition_list[0].artist.pen_name,
              this.artist_bio = this.exhibition_list[0].artist.bio
            }
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$notify({
            group: "error",
            title: "Error",
            text: "Something went wrong"
          });
        });
    },

    getArtistDetails(){
      this.$store
        .dispatch("getArtist", this.artist_slug)
        .then((res) => {
          this.artist_image = res.user_profile.avatar,
          this.artist_full_name = res.pen_name,
          this.artist_bio = res.bio
           
        })
        .catch((err) => {
          this.$notify({
            group: "error",
            title: "Error",
            text: "Something went wrong"
          });
        });
    },

    load_next_or_previous_exhibition(url) {
      let url_with_filter = url;
      this.loading = true;
      this.$store
        .dispatch("getNextOrPreviousExhibitions", url_with_filter)
        .then((res) => {
          if (res.results) {
            if (res.next) {
              this.next_url = res.next;
            }
            if (res.previous) {
              this.previous_url = res.previous;
            }
            // this.$store.commit("setExhibitionList", res);
            this.exhibition_list = res.results;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$notify({
            group: "error",
            title: "Error",
            text: "Something went wrong",
          });
        });
    },
    searchExhibition() {
      if (this.search_exhibition === "") {
        this.search_flag = true;
        this.search_exhibition_list = {};
      } else {
        let search_meta_data = {
          filter_string: this.filter_string,
          search_keyword: this.search_exhibition,
        };
        this.loading = true;
        this.search_exhibition = this.search_exhibition.trim();
        if (this.search_exhibition != "") {
          this.$store
            .dispatch("searchExhibitions", search_meta_data)
            .then((res) => {
              if (res.results) {
                if (res.next) {
                  this.next_url = res.next;
                }
                if (res.previous) {
                  this.previous_url = res.previous;
                }
                // this.$store.commit("setExhibitionList", res);
                this.search_flag = false;
                this.search_exhibition_list = res.results;
                this.loading = false;
              }
            })
            .catch((err) => {
              this.$notify({
                group: "error",
                title: "Error",
                text: "Something went wrong",
              });
            });
        } else {
          this.search_flag = true;
          this.search_exhibition_list = {};
        }
      }
    },
  },

  computed: {
    getExhibition() {
      return this.$store.getters.getExhibitionList.results;
    },
  },

  created() {
    this.artist_slug = this.$router.currentRoute.params.artist_slug;
    this.load_initial_exhibitions();
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
*:focus {
  outline: none;
  box-shadow: none;
}

@media (max-width: 992px) {
  .ex-card {
    width: 100% !important;
    margin: 0 5px;
    padding: 10px;
  }
}

/deep/ .thumb {
    width: 250px;
    height: 250px;
  }

</style>